<template>
  <div class="flex-col page">
    <div class="flex-col content">
      <div class="flex-row self-center group_5">
        <div class="flex-col self-start group_8 ml-43">
          <span class="self-start font_2">账号密码修改</span>
          <div class="flex-row items-center self-stretch group_9">
            <span class="font_4">原密码</span>
            <div class="flex-col justify-start items-start shrink-0 text-wrapper ml-11">
              <el-input type="password" size="mini" class="value" placeholder="请输入原密码" v-model="old"></el-input>
            </div>
          </div>
          <div class="flex-row items-center self-stretch group_10">
            <span class="font_4">新密码</span>
            <div class="flex-col justify-start items-center shrink-0 text-wrapper ml-11">
              <el-input type="password" size="mini" class="value" placeholder="6-16位，必须包含数字或字母" v-model="password"></el-input>
            </div>
          </div>
          <div class="flex-row items-center self-stretch group_12">
            <span class="font_4">确认密码</span>
            <div class="flex-col justify-start items-start shrink-0 text-wrapper">
              <el-input type="password" size="mini" class="value" placeholder="请再次填写上面的密码" v-model="repassword"></el-input>
            </div>
          </div>
          <el-button class="btn" type="primary" @click="submitPassword">确认修改</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      old: '',
      password: '',
      repassword: ''
    }
  },

  methods: {
    async submitPassword () {
      const config = {
        old: this.old,
        password: this.password,
        repassword: this.repassword
      }
      const res = await this.$https.profile(config)
      if (res.data.status === 1) {
        this.$message.success('修改成功')
        setTimeout(() => {
          window.location.href = '/#/login'
        }, 500)
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .btn{
    padding: 8px 0;
    background-color: #0071d6;
    border-color: #0071d6;
    border-radius: 2px;
    width: 94px;
    height: 32px;
    margin-left: 67px;
    margin-top: 30px;
    cursor: pointer;
  }
  .font_4{
    width: 67px;
  }
  .flex-col /deep/ .el-input{
    width: 264px;
    background: #FFFFFF;
  }
  .content{
    flex-direction: row;
  }
  .ml-2-5 {
    margin-left: 2.5px;
  }
  .ml-9 {
    margin-left: 9px;
  }
  .ml-4-5 {
    margin-left: 4.5px;
  }
  .ml-43 {
    /*margin-left: 43px;*/
  }
  .ml-11 {
    /*margin-left: 11px;*/
  }
  .mt-7-5 {
    margin-top: 7.5px;
  }
  .ml-19 {
    margin-left: 19px;
  }
  .ml-8-5 {
    margin-left: 8.5px;
  }
  .mt-13-5 {
    margin-top: 13.5px;
  }
  .ml-49-5 {
    margin-left: 49.5px;
  }
  .ml-5 {
    margin-left: 5px;
  }
  .mt-7 {
    margin-top: 7px;
  }
  .page {
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 18.5px;
      .section {
        padding: 26.5px 0 24.5px;
        background-color: #ffffff;
        .text_2 {
          color: #004290;
          font-size: 19.5px;
          font-family: Swiss721BT;
          font-weight: 900;
          line-height: 14.5px;
        }
        .text_3 {
          color: #004290;
          font-size: 16px;
          font-family: Alibaba;
          line-height: 15.5px;
        }
      }
      .section_2 {
        padding: 8px 181px 8px 194px;
        background-color: #006ed1;
        .group_2 {
          margin-left: 42.5px;
        }
        .group_3 {
          margin-left: 40px;
        }
        .image_2 {
          width: 6.5px;
          height: 4px;
        }
        .group_4 {
          margin-left: 40.5px;
        }
        .image {
          width: 14px;
          height: 16px;
        }
        .text_4 {
          color: #ffffff;
        }
      }
    }
    .group_5 {
      /*border-top: solid 1.5px #0067d1;*/
      .group_6 {
        padding: 106px 0 181px;
        width: 100.5px;
        .section_4 {
          background-color: #006ed1;
          width: 2.5px;
          height: 18.5px;
        }
        .section_3 {
          padding: 28.5px 12px 156.5px;
          background-color: #f9f9f9;
          .group_7 {
            padding: 0 16px;
            .image_3 {
              width: 9px;
              height: 9.5px;
            }
            .text_5 {
              line-height: 6.5px;
            }
            .image_4 {
              width: 9px;
              height: 10px;
            }
            .text_9 {
              color: #006ed1;
            }
            .image_6 {
              width: 9px;
              height: 9px;
            }
          }
          .view {
            margin-top: 18px;
          }
          .group_11 {
            margin-top: 17.5px;
            padding-left: 16px;
            .image_5 {
              width: 10px;
              height: 10px;
            }
            .text_7 {
              line-height: 6.5px;
            }
          }
          .font_3 {
            font-size: 7px;
            font-family: PingFang;
            line-height: 7px;
            color: #666666;
          }
          .view_2 {
            margin-top: 17px;
          }
          .view_3 {
            margin-top: 20px;
          }
        }
        .pos {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
      .group_8 {
        /*margin-right: 411px;*/
        /*margin-top: 29.5px;*/
        .group_9 {
          margin-top: 34px;
        }
        .group_10 {
          margin-top: 19px;
        }
        .font_4 {
          font-size: 14px;
          font-family: PingFang;
          color: #333333;
        }
        .text-wrapper {
          /*padding: 5px 0;*/
          /*background-color: #ffffff;*/
          /*width: 132px;*/
          /*height: 18px;*/
          /*border-left: solid 0.5px #e5e5e5;*/
          /*border-right: solid 0.5px #e5e5e5;*/
          /*border-top: solid 0.5px #e5e5e5;*/
          /*border-bottom: solid 0.5px #e5e5e5;*/
          .font_5 {
            font-size: 14px;
            font-family: PingFang;
            line-height: 14px;
            color: #999999;
          }
          .text_6 {
            margin-left: 7px;
          }
          .text_8 {
            line-height: 7.5px;
          }
          .text_10 {
            margin-left: 7px;
          }
        }
        .group_12 {
          margin-top: 19px;
        }
      }
    }
    .font_2 {
      font-size: 16px;
      font-family: PingFang;
      /*line-height: 8px;*/
      color: #333333;
    }
    .image_7 {
      margin-left: 134px;
      width: 13px;
      height: 13px;
    }
    .section_5 {
      padding: 31.5px 123px 0;
      background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=2f798bef24b196189592eae0d81878ee.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .text-wrapper_2 {
        padding: 7px 0;
        background-color: #006ed1;
        width: 82px;
      }
      .group_13 {
        padding: 13px 3px 24.5px;
        .text-wrapper_3 {
          flex: 1 1 223px;
          padding: 14px 0;
          background-color: #e0edf9;
          height: 37.5px;
          border-left: solid 0.5px #006ed1;
          border-right: solid 0.5px #006ed1;
          border-top: solid 0.5px #006ed1;
          border-bottom: solid 0.5px #006ed1;
        }
      }
    }
    .font {
      font-size: 9px;
      font-family: PingFang;
      line-height: 9px;
      color: #ffffff;
    }
    .text {
      text-transform: uppercase;
    }
    .section_6 {
      padding: 4px 117px 18px 180px;
      background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=4d73456eb0616f8bd0f475b81babc110.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .image_8 {
        width: 20.5px;
        height: 20.5px;
      }
      .text_11 {
        color: #b2b3b8;
        font-size: 12px;
        font-family: PingFang;
        line-height: 11.5px;
      }
      .image_9 {
        margin-bottom: 2px;
        width: 20px;
        height: 21.5px;
      }
      .text_12 {
        color: #b2b3b8;
        font-size: 8px;
        font-family: PingFang;
        line-height: 7.5px;
      }
      .text_14 {
        color: #006ed1;
        font-size: 12px;
        font-family: PingFang;
        font-weight: 700;
        line-height: 10px;
      }
      .image_10 {
        margin-bottom: 2px;
        width: 15.5px;
        height: 21.5px;
      }
      .text_13 {
        color: #b2b3b8;
      }
      .text_15 {
        color: #006ed1;
        font-size: 10px;
        font-family: PingFang;
        line-height: 9.5px;
      }
      .section_7 {
        background-color: #2e3142;
        width: 102px;
        height: 94px;
      }
      .font_6 {
        font-size: 7px;
        font-family: PingFang;
        line-height: 5.5px;
        color: #939598;
      }
      .text_16 {
        margin-left: 1.5px;
      }
      .text_17 {
        margin-left: 22.5px;
      }
      .text_18 {
        margin-left: 1.5px;
      }
    }
  }
</style>
